import request from '../Functions/ajax/request'


export default function ArticleLoader ({ params })
{
	return { page: getNews(params) };
}

async function getNews (params)
{
	try
	{
		var response = await request('/news/get')
		.config({ })
		.post({ slug: params.slug });
	}
	catch (e)
	{
		throw { code: 404, throw_up: true, message: e?.error };
	}

	return { article: response.news };
}